import ArrowDownIcon from "@pages/profile-v2/assets/icons/ArrowDownIcon.jsx";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
	BonusItemWrapper,
	ButtonText,
	ContentInfo,
	Date,
	DateWrapper,
	Detail,
	DetailWrapper,
	DetailsButton,
	Info,
	InfoTitle,
	ItemContent,
	ItemHeader,
	WagerInfo,
} from "./elements";

const AllowedFsTargets = ["Casino", "Sportsbook", "LiveCasino"];

const BonusItem = ({
	data,
	index,
	translate,
	openIndex,
	setOpenIndex,
	remainingAmount,
	isBonus,
	fsBonusData,
}) => {
	const bonusName = isBonus
		? fsBonusData?.walletContributions[0]?.name || fsBonusData?.bonus?.name
		: data?.bonus?.name;
	const amount = data?.walletContributions?.[0]?.amount?.value || data?.balance?.value;
	const currency = data?.walletContributions?.[0]?.amount?.currency || data?.balance?.currency;
	const wagerPercentage = isBonus
		? fsBonusData?.walletContributions[0]?.wageringRatio || 0
		: data?.walletContributions[0]?.wageringRatio || 0;
	const startDate = isBonus
		? moment(fsBonusData?.baseAmountDetails?.convertedAt).format("DD/MM/YYYY HH:mm")
		: moment(data?.baseAmountDetails?.convertedAt).format("DD/MM/YYYY HH:mm");
	const endDate = isBonus
		? moment(fsBonusData?.baseAmountDetails?.convertedAt)
				.add(1, "years")
				.format("DD/MM/YYYY HH:mm")
		: moment(data?.baseAmountDetails?.convertedAt)
				.add(data?.bonus?.triggerExpirationDays, "days")
				.format("DD/MM/YYYY HH:mm");
	const allowedTargets = isBonus
		? AllowedFsTargets
		: Object.keys(data?.bonus?.limits).filter((i) => data.bonus.limits[i].isAllowed);
	const areDetailsOpen = openIndex === index;

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const shouldShowDetails = windowWidth >= 768 || areDetailsOpen;

	return (
		<BonusItemWrapper>
			<ItemHeader>{bonusName}</ItemHeader>
			<ItemContent>
				<ContentInfo>
					<InfoTitle>{translate("BONUS")}:</InfoTitle>
					<Info>
						{amount} {currency === "FreeSpin Token" ? "FS Token" : currency}
					</Info>
				</ContentInfo>
				{(remainingAmount || fsBonusData?.wagering?.remainingAmount) && (
					<ContentInfo>
						{/* <InfoTitle>{translate("Remaining")}:</InfoTitle> */}
						<Info>
							{remainingAmount || fsBonusData.wagering.remainingAmount}{" "}
							{!fsBonusData.wagering.remainingAmount && currency}
						</Info>
					</ContentInfo>
				)}
				<ContentInfo>
					<WagerInfo>{`%${parseFloat(wagerPercentage)}`}</WagerInfo>
				</ContentInfo>
			</ItemContent>
			{shouldShowDetails ? (
				<DetailWrapper>
					<Detail>{`Available in ${allowedTargets
						.map((i) => i.toUpperCase())
						.join(", ")}`}</Detail>
					<DateWrapper>
						<Date>
							{translate("Start")}: {startDate}
						</Date>
						<Date>
							{translate("Last")}: {endDate}
						</Date>
					</DateWrapper>
				</DetailWrapper>
			) : null}
			{windowWidth < 768 && (
				<DetailsButton
					rotate={areDetailsOpen}
					onClick={() => setOpenIndex(areDetailsOpen ? -1 : index)}>
					<ButtonText>
						{!areDetailsOpen ? translate("DETAILS") : translate("HIDE")}
					</ButtonText>
					<ArrowDownIcon />
				</DetailsButton>
			)}
		</BonusItemWrapper>
	);
};

export default BonusItem;
